import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Maintenance from './components/Maintenance';
import './index.css';

const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === '1';

if (!maintenanceMode && window.location.pathname === '/maintenance') {
  window.history.replaceState(null, '', '/');
}

ReactDOM.render(
  maintenanceMode ? <Maintenance /> : <App />,
  document.getElementById('root')
);
